// extracted by mini-css-extract-plugin
module.exports = {"messagePage":"messagePage_messagePage__jihlU","subtitle":"messagePage_subtitle__23W4Z","icon":"messagePage_icon__2_1Iu","errorIcon":"messagePage_errorIcon__1qjZR"};